export default (() => {
  const overlay = $('#overlay-menu')
  const hamburger = $('#overlay-menu-toggle')
  
  hamburger.on('click', function() {
    $(this).toggleClass('is-active');
    $('body').toggleClass('locked');
    overlay.fadeToggle();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var overlayMenu = document.getElementById('overlay-menu');
    var internalLinks = overlayMenu.querySelectorAll('a[href^="#"]');
    var toggleButton = document.getElementById('overlay-menu-toggle');

    internalLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        // Close the overlay menu when an internal anchor link is clicked
        overlayMenu.style.display = 'none';

        // Remove the 'is-active' class from the toggle button
        toggleButton.classList.remove('is-active');
        $('body').removeClass('locked');
      });
    });
  });
})();


// WEBPACK FOOTER //
// ./scripts/layout/overlay-menu.js